/**
 * https://disaportal.gsi.go.jp/hazardmap/copyright/opendata.html#newl1
 * @type {PlanFlood}
 * 洪水浸水想定区域（計画規模）
 */
module.exports = class PlanFlood {

  /**
   * Constructor
   */
  constructor() {
  }

  /**
   * To display table
   */
  toDisplay() {
    return [
      {
        alt      : '洪水浸水想定区域の凡例',
        img      : 'https://cdn.jon-api.com/shikaku-map/usage-guide/flood.png',
        sourceUrl: 'https://disaportal.gsi.go.jp/hazardmap/copyright/opendata.html#newl1'
      }
    ];
  }
}
